import React from 'react';
import ServerError from '../../../../components/ServerError';
import { SkeletonTable } from '../Skeleton/Table';
import { SkillGapCard } from './SkillGapCard';
import { useEmployeeSkillGap } from './useEmployeeSkillGap';

type Props = {
  employeeId: string;
  // When embedded as a secondary panel (e.g. the performance review sidebar),
  // render nothing while loading/failed/empty so a supplementary gap view never
  // dominates the surface with a skeleton, a full-page error, or an empty card.
  hideWhenUnavailable?: boolean;
};

export const EmployeeSkillGap: React.FC<Props> = ({
  employeeId,
  hideWhenUnavailable = false,
}) => {
  const { rows, loading, error } = useEmployeeSkillGap(employeeId);

  if (error) {
    return hideWhenUnavailable ? null : <ServerError />;
  }
  if (loading) {
    return hideWhenUnavailable ? null : <SkeletonTable columns={3} rows={4} />;
  }
  if (rows.length === 0 && hideWhenUnavailable) {
    return null;
  }
  return <SkillGapCard rows={rows} />;
};
